let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iUzmZ")).then(() => parcelRequire('kXVNP'));